import logo from './logo.png'

const Logo = () => <img className='Logo' src={logo} alt='Parco' />

export default Logo
